import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { Form, Input, InputNumber, Select, TimePicker, Row, Col } from "antd";
import { useWatch } from "antd/es/form/Form";
import DynamicConfigPanel from "./components/DynamicConfigPanel";

export default function HealthTempForm({ form, item, tempType }: any) {
    const [selectedTempType, setSelectedTempType] = useState<string>('');
    const currentTempType = useWatch('tempType', form);

    useEffect(() => {
        if (item?.id) {
            form.setFieldsValue({
                ...item,
                startTime: item.startTime ? dayjs(item.startTime, 'HH:mm') : null,
                endTime: item.endTime ? dayjs(item.endTime, 'HH:mm') : null,
            });
            setSelectedTempType(item.tempType || '');
        } else {
            form.resetFields();
            setSelectedTempType('');
        }
    }, [item, form]);

    // 监听模板类型变化
    useEffect(() => {
        if (currentTempType !== selectedTempType && currentTempType !== undefined) {
            setSelectedTempType(currentTempType);
            // 只清空 data 字段，不影响其他表单域
            form.setFieldsValue({ data: undefined });
        }
    }, [currentTempType, selectedTempType, form]);

    return (
        <Form form={form} size="middle" name="HealthTempForm" style={{ maxHeight: "70vh", overflowY: "scroll" }}
            labelCol={{ span: 3 }} wrapperCol={{ span: 20 }} labelWrap={true} colon={false}
            scrollToFirstError={true}>
            <Form.Item label="模版标题" name="title" rules={[{ required: true, message: '不能为空' }]}>
                <Input placeholder="请输入模版标题" />
            </Form.Item>
            <Form.Item label="备注" name="remark">
                <Input.TextArea placeholder="请输入备注信息" autoSize={{ minRows: 1, maxRows: 5 }} />
            </Form.Item>
            <Row>
                <Col span={12}>
                    <Form.Item
                        label="可以完成次数"
                        name="totalCompletedNumber"
                        initialValue={1}
                        rules={[{ required: true, message: '不能为空' }]}
                        labelCol={{ span: 6 }}
                        wrapperCol={{ span: 17 }}
                    >
                        <InputNumber placeholder="请输入可以完成次数(默认1次)" precision={0} style={{ width: '100%' }} addonAfter={'次'} />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        label="循环周期"
                        name="cyclePeriod"
                        initialValue={1}
                        rules={[{ required: true, message: '不能为空' }]}
                        labelCol={{ span: 6 }}
                        wrapperCol={{ span: 16 }}
                    >
                        <InputNumber placeholder="请输入循环周期(单位天，默认1天)" precision={0} style={{ width: '100%' }} addonAfter={'天'} />
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={12}>
                    <Form.Item
                        label="开始时间"
                        name="startTime"
                        rules={[{ required: true, message: '不能为空' }]}
                        labelCol={{ span: 6 }}
                        wrapperCol={{ span: 17 }}
                    >
                        <TimePicker
                            format="HH:mm"
                            placeholder="请选择开始时间"
                            onChange={(time) => {
                                const endTime = form.getFieldValue('endTime');
                                // 如果结束时间为空，则自动设置为开始时间
                                if (!endTime) {
                                    form.setFieldsValue({ endTime: time });
                                }
                            }}
                            style={{ width: '100%' }}
                        />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        label="结束时间"
                        name="endTime"
                        labelCol={{ span: 6 }}
                        wrapperCol={{ span: 16 }}
                    >
                        <TimePicker
                            format="HH:mm"
                            placeholder="请选择结束时间"
                            style={{ width: '100%' }}
                        />
                    </Form.Item>
                </Col>
            </Row>
            <Form.Item label="时间备注" name="timeRemark">
                <Input.TextArea placeholder="请输入备注信息" autoSize={{ minRows: 1, maxRows: 5 }} />
            </Form.Item>
            <Row>
                <Col span={12}>
                    <Form.Item
                        label="最小支持版本号"
                        name="minVersionCode"
                        labelCol={{ span: 6 }}
                        wrapperCol={{ span: 17 }}
                    >
                        <InputNumber
                            placeholder="请输入最小支持版本号, 如100"
                            style={{ width: '100%' }}
                            onChange={() => form.validateFields(['maxVersionCode'])}
                        />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        label="最大支持版本号"
                        name="maxVersionCode"
                        labelCol={{ span: 6 }}
                        wrapperCol={{ span: 16 }}
                        rules={[
                            {
                                validator: async (_, value) => {
                                    const minVersion = form.getFieldValue('minVersionCode');
                                    if (value && minVersion && value < minVersion) {
                                        throw new Error('最大支持版本号必须超过最小支持版本号');
                                    }
                                },
                            },
                        ]}
                    >
                        <InputNumber placeholder="请输入最大支持版本号, 如110" style={{ width: '100%' }} />
                    </Form.Item>
                </Col>
            </Row>
            <Form.Item label="模版类型" name="tempType" rules={[{ required: true, message: '不能为空' }]}>
                <Select
                    placeholder="请选择模版类型"
                    options={tempType.map((item: any) => ({
                        label: item.dictValue,
                        value: item.dictKey,
                    }))}
                />
            </Form.Item>
            <DynamicConfigPanel
                form={form}
                dataType={selectedTempType}
                prefix={['data']}
            />
        </Form>
    )
}